import { type FC } from 'react';

import { EsgCategory } from '@/api/esg/models/EsgCategory';
import { EsgCurrencyCategory } from '@/api/esg/models/EsgCurrencyCategory';
import { Center } from '@/components/Center';
import { Gauge } from '@/components/Charts';
import { Column, Row } from '@/components/Grid';
import { useTexts } from '@/hooks/useTexts';

import { EsgOverviewValueList } from './EsgOverviewValueList';

interface Props {
  solutionCompanies: EsgCategory;
  euTaxonomyAlignment: EsgCategory;
  euTaxonomyEligibility: EsgCategory;
  carbonIntensities: EsgCurrencyCategory[];
  pai11GhgEmissionsSum: EsgCategory | undefined;
}

export const EsgOverview: FC<Props> = ({
  solutionCompanies,
  euTaxonomyAlignment,
  euTaxonomyEligibility,
  carbonIntensities,
  pai11GhgEmissionsSum,
}) => {
  const fms = useTexts();

  const texts = fms.pages.esg.overview;

  return (
    <Row>
      <Column $span={4}>
        <Center horizontal vertical>
          <Gauge
            percent={solutionCompanies.kpi.value}
            description={texts.sustainableInvestments}
          />
        </Center>
      </Column>

      <Column $span={8}>
        <EsgOverviewValueList
          solutionCompanies={solutionCompanies}
          euTaxonomyAlignment={euTaxonomyAlignment}
          euTaxonomyEligibility={euTaxonomyEligibility}
          carbonIntensities={carbonIntensities}
          pai11GhgEmissionsSum={pai11GhgEmissionsSum}
        />
      </Column>
    </Row>
  );
};
